'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _header = require('./../../header');

var _header2 = _interopRequireDefault(_header);

var _MPPMinimalHeaderDefaultProps = require('./MPPMinimalHeaderDefaultProps');

var _MPPMinimalHeaderDefaultProps2 = _interopRequireDefault(_MPPMinimalHeaderDefaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MPPMinimalHeader = function MPPMinimalHeader(props) {
  return _react2.default.createElement(_header2.default, props);
};

MPPMinimalHeader.defaultProps = _MPPMinimalHeaderDefaultProps2.default;
exports.default = MPPMinimalHeader;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/minimal-header/jsx/MPPMinimalHeader.js
// module id = 1118
// module chunks = 4